/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from 'react';
import { Form, Modal, Upload, Select, message } from 'antd';
import { CompSelector } from '../../common';
import { DataService } from '../../../config/dataService/dataService';
import {  DOC_FILE_TYPES, DOC_TYPES } from '../../../config/config';

const initialState = { address: '' };
const { Dragger } = Upload;
const { Option } = Select;

const FormDialog = ({ showDialog, disableOutSideCLose = false, isEdit = false, setReload }) => {
  const [form] = Form.useForm();
  const [compID, setCompID] = useState(null)
  const [busy, setBusy] = useState(false);
  const [selectedFile, setSelectedFile] = useState(false);
  const [docFileType, setDocFileType] = useState(null);
  const [docType, setDocType] = useState(null);

  // Custom Request for Upload
  const handleSubmit = async ({ file, onProgress, onError, onSuccess }) => {
    try {
      setBusy(true);
      // Simulate a payload if required
      const payload = new FormData();
      payload.append('document', file);
      payload.append('comp_id', compID);
      payload.append('doc_file_type', docFileType);
      payload.append('doc_type', docType);

      // Progress simulation
      // let percent = 0;
      // const interval = setInterval(() => {
      //   percent += 10;
      //   if (percent > 90) clearInterval(interval);
      //   onProgress({ percent });
      // }, 200);

      // Post file to the server
      const response = await DataService.post('/comp-att/create', payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        // onUploadProgress: (progressEvent) => {
        //   const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        //   onProgress({ percent: percentCompleted });
        // },
      });

      // clearInterval(interval);

      if (response.data.status) {
        onSuccess(response.data, file);
        message.success(response.data.message);
        showDialog(false);
        setReload(true);
      } else {
        onError(new Error(response.data.message));
        message.error(`Error: ${response.data.message}`);
      }
    } catch (error) {
      onError(error);
      message.error(`Error uploading file: ${error.message}`);
    } finally {
      setBusy(false);
    }
  };

  // Validation before upload
  const beforeUpload = (file) => {
    if (!compID) {
      message.error('Please select a company first');
      return Upload.LIST_IGNORE; // Prevents the file from being added to the upload list
    }
    if (!docFileType) {
      message.error('Please select a document file type first');
      return Upload.LIST_IGNORE; // Prevents the file from being added to the upload list
    }
    if (!docType) {
      message.error('Please select a document type first');
      return Upload.LIST_IGNORE; // Prevents the file from being added to the upload list
    }
    return true; // Allows the upload to proceed
  };

  const validateCompID = () => {
    if (!compID) {
      return Promise.reject(new Error('Please select a company!'));
    }
    return Promise.resolve();
  };

  const validateSelecteFile = () => {
    if (!selectedFile) {
      return Promise.reject(new Error('Please upload a document!'));
    }
    return Promise.resolve();
  };

  const validateFileType = () => {
    if (!docFileType) {
      return Promise.reject(new Error('Please select document file type!'));
    }
    return Promise.resolve();
  };

  const validateDocType = () => {
    if (!docType) {
      return Promise.reject(new Error('Please select document file!'));
    }
    return Promise.resolve();
  };

  const props = {
    name: 'file',
    multiple: false,
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    onChange(info) {
      const { status } = info.file;
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  // console.log('form', form)
  return (
    <Modal
      open
      title={isEdit ? 'Edit Record' : 'Add Record'}
      okText={isEdit ? 'Update' : 'Create'}
      cancelText="Cancel"
      width='70%'
      confirmLoading={busy}
      centered
      onCancel={(event) => {
        const { target, keyCode } = event
        if (['svg', 'span'].includes(String(target.nodeName).toLowerCase())) showDialog(false)
        if (keyCode === 27) showDialog(false)
      }}
      onOk={() => form.submit()}
      cancelButtonProps={{
        disabled: busy
      }}
      okButtonProps={{
        hidden: true
      }}
      destroyOnClose
      closable={false}
    >
      <Form
        layout="horizontal"
        form={form}
        // onFinish={handleSubmit}
        disabled={busy}
        labelCol={{ span: 6 }} // Adjust label width
        wrapperCol={{ span: 16 }} // Adjust input width
        initialValues={initialState}
      >
        <Form.Item
          name="compID"
          label="select company"
          validateTrigger="onBlur"
          rules={[{ required: true, validator: validateCompID }]}
        >
          <CompSelector onItemSelected={setCompID} />
        </Form.Item>
        <Form.Item
          name="docFileType"

          label="Select File Type"
          validateTrigger="onBlur"
          rules={[{ required: true, validator: validateFileType }]}
        >
          <Select
            placeholder="Select a file type"
            optionFilterProp="children"
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={value => setDocFileType(value)}
          >
            {DOC_FILE_TYPES.map(item => <Option value={item.id}>{item.label}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item
          name="docType"
          label="Select Document Type"
          validateTrigger="onBlur"
          rules={[{ required: true, validator: validateDocType }]}
        >
          <Select
            placeholder="Select a document type"
            optionFilterProp="children"

            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={value => setDocType(value)}
          >
            {DOC_TYPES.map(item => <Option value={item.id}>{item.label}</Option>)}
          </Select>
        </Form.Item>

        <Form.Item
          label="Upload Document"
          rules={[{ required: true, validator: validateSelecteFile }]}
        >
          <Dragger {...props} customRequest={handleSubmit} beforeUpload={beforeUpload}>
            <p className="ant-upload-text">Drop files here to upload</p>
          </Dragger>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FormDialog;
